import React from 'react';

import { getThematicColorBySlug } from '../../resources/thematic-topics';

import SubRecord from './CountryProfileSubRecord';
import CountryProfileSubSection from './CountryProfileSubSection';

import { slugify } from '../../helpers/format';

class CountryProfileSection extends React.Component {
  renderSubSections() {
    const data = this.props.data;
    return data.map((item, index) => {
      return (
        <CountryProfileSubSection
          key={ index }
          name={ item.name }
          data={ item.answers }
        />
      );
    });
  };

  render() {
    const name = this.props.name,
      color = getThematicColorBySlug(slugify(name));

    return (
      <SubRecord title={ name } color={ color }>
        { this.renderSubSections() }
      </SubRecord>
    );
  }
}

export default CountryProfileSection;




// WEBPACK FOOTER //
// ./src/components/CountryProfile/CountryProfileSection.js